import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-icon-feather',
  templateUrl: './icon-feather.component.html',
  styleUrls: ['./icon-feather.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconFeatherComponent {

  private _icon: string;

  private readonly url = '/assets/icon/feather-sprite.svg#';

  @Input() width = 16;

  @Input() height = 16;

  @Input() strokeWidth = 0;

  @Input() strokeLinecap = 'round';

  @Input() strokeLinejoin = 'round';

  @Input() stroke = '#2A2A2A';

  @Input() fill = 'none';

  @Input() set icon(icon: string) {
    this._icon = `${this.url}${icon}`;
  }

  get icon(): string {
    return this._icon;
  }
}
